/*
 * Tendencia semanal (puntualidad, asistencia y llegadas antes de la hora oficial, en %) y horas trabajadas
 * por persona en el periodo (las 15 con más horas, barras horizontales). Sin horas extra (spec 4.3).
 * Las semanas parciales (primera/última del periodo o sin datos) se rotulan "(parcial)" y sus valores null
 * quedan como huecos en la línea, nunca como ceros. "Horas por persona" es el TOTAL del periodo (no el
 * promedio por jornada completa del KPI "horas por persona al día"). Valores del servidor, sin recalcular.
 * Quienes no tienen jornadas completas no se ocultan: se listan aparte (con nombres hasta 10, luego solo el conteo).
 */
import React from "react";
import {BarChart, TrendChart} from "../../components/charts";
import {topHours, weeklyTrendChart, weeklyTrendLabel} from "../../utils/dashboard";

const TrendPanels = ({datos}) => {
    const trend = weeklyTrendChart(datos.tendencia_semanal, datos.periodo);
    const hasTrendData = trend.series.some((serie) => serie.data.some((value) => value !== null && value !== undefined));
    const hours = topHours(datos.horas_por_persona.filter((row) => row.horas > 0));
    const without = datos.horas_por_persona.filter((row) => !(row.horas > 0));
    return (
        <div className="mc-grid mc-grid--2">
            <div className="mc-panel">
                <h3 className="mc-panel__title">Tendencia semanal</h3>
                <p className="mc-panel__hint">Semanas de lunes a domingo dentro del periodo. Las semanas parciales pueden no tener dato.</p>
                {hasTrendData ? (
                    <TrendChart categories={trend.categories} series={trend.series}
                                label={`Tendencia semanal de ${trend.categories.length} semanas`}
                                summary={`Tendencia semanal en porcentaje. ${weeklyTrendLabel(trend)}`}/>
                ) : <p className="mc-inline-empty">El periodo todavía no tiene días transcurridos con datos.</p>}
            </div>
            <div className="mc-panel">
                <h3 className="mc-panel__title">Horas por persona (total del periodo)</h3>
                <p className="mc-panel__hint">Suma de horas de las jornadas completas del rango, no el promedio por día. Las 15 personas con más horas.</p>
                {hours.values.length ? (
                    <BarChart categories={hours.categories} values={hours.values} horizontal unit=" h"
                              height={60 + 30 * hours.values.length} label="Horas totales por persona"
                              summary={`Horas totales del periodo por persona. ${hours.label}`}/>
                ) : <p className="mc-inline-empty">Sin jornadas completas en este rango.</p>}
                {without.length ? (
                    <p className="mc-chart-note">
                        {without.length} {without.length === 1 ? 'persona sin jornadas completas' : 'personas sin jornadas completas'} en el periodo
                        {without.length <= 10 ? `: ${without.map((row) => row.empleado).join(', ')}.` : '.'}
                    </p>
                ) : null}
            </div>
        </div>
    );
};

export default TrendPanels;
